import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Meantemplate extends Component {
  render() {
    const course = [
       {
         title: "Introduction to MEAN Stack",
          content: [
            "Overview of MEAN Stack",
            "Understanding each component (MongoDB, Express.js, Angular, Node.js)",
            "Benefits and use cases of MEAN Stack",
            "Setting up the development environment"
          ]
        }, {
         title: "MongoDB: NoSQL Database",
          content: [
            "Introduction to MongoDB",
            "Installation and setup",
            "CRUD operations in MongoDB",
            "Data modeling in MongoDB",
            "Advanced queries and indexing"
          ]
        }, {
         title: "Express.js: Backend Framework",
          content: [
            "Introduction to Express.js",
            "Setting up a basic server",
            "Routing and middleware",
            "Working with requests and responses",
            "Error handling and middleware"
          ]
        }, {
         title: "Angular: Frontend Framework",
          content: [
            "Introduction to Angular",
            "Components, templates, and data binding",
            "Services and dependency injection",
            "Routing and navigation",
            "Forms and form validation"
          ]
        }, {
         title: "Node.js: Server-side JavaScript",
          content: [
            "Introduction to Node.js",
            "Setting up a Node.js server",
            "Working with modules and packages",
            "File system operations",
            "Event-driven programming with EventEmitter"
          ]
        }, {
         title: "Authentication and Authorization",
          content: [
            "User authentication strategies",
            "Implementing JWT (JSON Web Tokens) for authentication",
            "Role-based access control (RBAC)",
            "Securing routes and resources",
            "OAuth and OAuth2 for third-party authentication"
          ]
        }, {
         title: "Database Integration with Express",
          content: [
            "Connecting Express.js with MongoDB",
            "Using Mongoose for data modeling",
            "CRUD operations with Express and MongoDB",
            "Error handling and validation",
            "Managing database connections"
          ]
        }, {
         title: "Real-time Communication with Socket.IO",
          content: [
            "Introduction to WebSocket and Socket.IO",
            "Setting up Socket.IO in MEAN Stack",
            "Real-time events and broadcasting",
            "Handling socket connections",
            "Building real-time features"
          ]
        }, {
         title: "RESTful APIs and Microservices",
          content: [
            "Designing RESTful APIs",
            "Creating routes and endpoints",
            "Implementing CRUD operations",
            "Versioning APIs",
            "Microservices architecture and communication"
          ]
        }, {
         title: "Deployment and DevOps",
          content: [
            "Deploying MEAN Stack applications",
            "Continuous integration and continuous deployment (CI/CD)",
            "Containerization with Docker",
            "Managing and scaling applications",
            "Monitoring and logging"
          ]
        }, {
         title: "Testing and Quality Assurance",
          content: [
            "Types of testing (unit testing, integration testing, end-to-end testing)",
            "Testing tools and frameworks (Jasmine, Mocha, Chai)",
            "Writing test cases for MEAN Stack applications",
            "Automated testing and test coverage",
            "Debugging and troubleshooting"
          ]
        }
    ]

    const faqData = [
      {
        question: 'What is the MEAN stack?',
        answer:
          'MEAN stands for MongoDB, Express.js, Angular, and Node.js. It is a popular full-stack JavaScript framework that allows developers to build modern, scalable, and high-performance web applications using a consistent language (JavaScript) across the entire application stack.',
      },
      {
        question: 'What topics are covered in the MEAN Full Stack course? ',
        answer:
          'Our MEAN Full Stack course covers a wide range of topics, including MongoDB (document database), Express.js (web application framework), Angular (front-end framework), Node.js (server-side JavaScript runtime), RESTful APIs, authentication and authorization, deployment, and best practices for building scalable and maintainable full-stack applications. ',
      },
      {
        question: 'Are there any prerequisites for learning MEAN Stack?',
        answer:
         ` It's recommended to have a basic understanding of JavaScript, HTML, and CSS. Familiarity with web development concepts will be helpful in grasping MEAN Stack technologies.`      
         },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Professionals with MEAN Stack skills can pursue roles like Full-Stack Developer, MEAN Stack Developer, Web Application Developer, JavaScript Developer, and more.'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To enroll in our MEAN Full Stack training, you should have basic programming knowledge like variables, loops, conditions, and functions. Understanding HTML, CSS, and JavaScript will help you learn more easily. Strong problem-solving and logical thinking abilities are needed to write clean, maintainable web code and overcome challenges. The MEAN stack technologies are versatile and constantly evolving, so you must be eager to explore their capabilities and learn about the latest updates. Our course requires hard work and dedication throughout the entire program duration."
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Aravind R",
          date:" May 19 ,2023",
          review:` ${this.props.title} Training in  ${this.props.location} is  the first step towards a successful career in web development. It equips you with the knowledge and skills to   efficient and maintainable  ${this.props.title}frameworks. You can ensure you receive top-notch education in  ${this.props.title} .`
     },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Dhasaradhan",
          date:" June 29 ,2023",
          review:`${this.props.title} certification and unlock the doors to a promising career in web development. Elevate your skills, prove your expertise, and stand out in the competitive field of software development.`
        
        },
  ]
 
     return(
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MEAN Stack is a combination of four powerful technologies: MongoDB (a NoSQL database), Express.js (a web application framework), Angular (a front-end framework), and Node.js (a back-end runtime environment). It's used to build dynamic and scalable web applications."/> */}
          
          <NewMainsec rating='4.1' students={"645"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="MEAN Stack is a combination of four powerful technologies: MongoDB (a NoSQL database), Express.js (a web application framework), Angular (a front-end framework), and Node.js (a back-end runtime environment). It's used to build dynamic and scalable web applications."/>

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		<Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`MEAN Stack training in ${this.props.location} is a highly sought-after program for individuals aspiring to excel in web development using MEAN Stack technologies. At Learnsoft.org, we provide top-quality MEAN Stack training courses in ${this.props.location} to empower professionals with comprehensive knowledge and hands-on experience in MEAN Stack development. Our seasoned instructors employ a practical approach, integrating real-world projects and exercises to deliver a well-rounded education. Whether you are a beginner in web development or aiming to expand your skill set, Learnsoft.org's MEAN Stack training in ${this.props.location} is the ideal choice to elevate your career in MEAN Stack application development, MongoDB, Express.js, Angular, and Node.js. Contact us today to explore our courses and embark on your MEAN Stack journey.`} 
    title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our MEAN Stack course encompasses a wide array of topics, including MongoDB, Express.js, Angular, and Node.js development. Our experienced instructors will mentor you through hands-on exercises and real-world projects, ensuring your grasp of the concepts and techniques employed in MEAN Stack development. By the course's conclusion, you will be proficient in implementing MEAN Stack practices in your own web development projects, whether they involve building dynamic web applications, APIs, or full-stack solutions."}/>
  </section>
 <Batchtime title={this.props.title} fees="35,999" offer="25,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Automation Testing" coupath7="automation-testing" cou6='Web Development' coupath6='web-development' cou4='Python Full Stack Developer' coupath4='python-full-stack-developer' cou='Web design' coupath='web-design' cou3='Ui-Ux Design' coupath3='ui-ux-design'
           cou9='Java Full Stack Developer ' coupath9='java-full-stack-developer' cou1='Software Testing' coupath1='software-testing'
          cou5='Mern stack Developer' coupath5='mern-stack-developer' cou2='Selenium' coupath2='selenium'  cou8='Digital Marketing' coupath8='digital-marketing' />


      </>
    );
  }
}
